export const CORE_OBTENER_ENTIDADES_BASICAS_REQUEST = 'CORE_OBTENER_ENTIDADES_BASICAS_REQUEST';
export const CORE_OBTENER_ENTIDADES_BASICAS_SUCCESS = 'CORE_OBTENER_ENTIDADES_BASICAS_SUCCESS';
export const CORE_OBTENER_ENTIDADES_BASICAS_FAILURE = 'CORE_OBTENER_ENTIDADES_BASICAS_FAILURE';

export const CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_REQUEST = 'CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_REQUEST';
export const CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_SUCCESS = 'CORE_OBTENER_ENTIDADES_BASICAS_EXTRA_SUCCESS';
